import { useNavigate } from "react-router-dom";
import { CurrentUser } from "./CurrentUser";
import { FaEllipsisH } from "react-icons/fa";
import { useEffect, useRef, useState } from "react";

export const Banner = () => {
    const navigate = useNavigate();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const menuRef = useRef(null);
    const elipsesColor = isMenuOpen ? '#3fc2cd': 'white';

    useEffect(() => {
        const closeMenuOnOutsideClick = (event) => {
            if (!menuRef.current?.contains(event.target)) {
                setIsMenuOpen(false);
            }
        };

        document.addEventListener("mousedown", closeMenuOnOutsideClick);

        return () => {
            document.removeEventListener("mousedown", closeMenuOnOutsideClick);
        };
    }, []);

    return (
        <div className="banner">
            <div className='banner-left' onClick={() => navigate('/')}>
                <img style={{width: '100px'}} src='https://appcontentimages.blob.core.windows.net/$web/snake-blackTeal.png'/>
                <span className='banner-header'>Ticket Admin Portal</span>
                <div
                    className="collapsable-btns"
                    ref={menuRef}
                    onClick={(event) => event.stopPropagation()}
                    onMouseEnter={() => setIsMenuOpen(true)}
                    onMouseLeave={() => setIsMenuOpen(false)}
                >
                    <FaEllipsisH 
                        size={15}
                        color={elipsesColor} 
                        style={{padding: '10px', borderRadius:'5px'}}
                    />

                    {isMenuOpen && (
                        <div className="collapsable-menu" role="menu">
                            <a className="collapsable-btn" href='/TicketOpsAdmin' role="menuitem">
                                Box Office Training Admin
                            </a>
                            <a
                                className="collapsable-btn"
                                target="_blank"
                                rel="noreferrer"
                                href='https://tickettraining.dbacks.com/'
                                role="menuitem"
                            >
                                Box Office Training
                            </a>
                            <a className="collapsable-btn" href='/CommerceManagement' role="menuitem">
                                Commerce Management
                            </a>
                        </div>
                    )}
                </div>
            </div>
            <div style={{display: 'flex', flexDirection:'column', alignItems: 'flex-end', paddingRight:'40px'}}>
            <CurrentUser/>
            </div>        
        </div>        
    );
}